import * as React from 'react';
import { TranslateFn, AnsViewComp } from '@wix/answers-app-core';
import { FormInput, DeprecatedButton, CheckIcon } from '@wix/answers-ui-libby';
import { isEmailValid } from '@wix/answers-lib';

export const emailFormKey = 'email-form';

export type EmailFormProps = {
	email?: string;
	onSubmit: (value: string) => Promise<void>;
	optional: boolean;
};

const translationPrefix = `widget-ng.chat.${emailFormKey}`;

export type EmailFormState = {
	email: string;
	validationError: string;
	isSubmitting: boolean;
};

export class EmailForm extends AnsViewComp<EmailFormProps, EmailFormState> {

	state: EmailFormState = {
		email: this.props.email || '',
		validationError: '',
		isSubmitting: false
	};

	tp: TranslateFn = (key, params) => {
		return this.props.t(`${translationPrefix}.${key}`, params);
	}

	onChange = (email: string) => this.setState({email, validationError: ''});

	onSubmit = async () => {
		if (!this.state.isSubmitting && !this.props.email) {
			const {email} = this.state;
			if (isEmailValid(email)) {
				this.setState({isSubmitting: true});
				try {
					await this.props.onSubmit(email);
				} finally {
					this.setState({isSubmitting: false});
				}
			} else {
				this.setState({validationError: this.props.t('widget-ng.chat.invalid-email')});
				return Promise.resolve();
			}
		}
	}

	render () {
		const {state, props} = this;
		const button = (
			<DeprecatedButton onClick={this.onSubmit}>
				{this.props.t('widget-ng.chat.contact-details.submit')}
			</DeprecatedButton>
		);

		return (
			<div className={emailFormKey}>
				<FormInput
					readOnly={!!this.props.email}
					validationError={this.state.validationError}
					value={state.email}
					onChange={this.onChange}
					placeholder={`${this.tp('placeholder')}${!props.optional ? '*' : ''}`}
					onEnter={this.onSubmit}
				/>
				{!this.props.email ? button : <div className='submitted'><CheckIcon/>{this.tp('email-submitted')}</div>}
			</div>
		);
	}
}
